import { useTheme } from "@mui/material/styles";

const TelemetryMenuIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5351 10.7979C21.4877 12.7505 21.4877 15.9163 19.5351 17.869M12.464 17.869C10.5114 15.9163 10.5114 12.7505 12.464 10.7979M10.1068 20.226C6.85242 16.9717 6.85242 11.6953 10.1068 8.44092M21.8923 8.44092C25.1466 11.6953 25.1466 16.9717 21.8923 20.226M15.9995 16.0001C16.92 16.0001 17.6662 15.2539 17.6662 14.3335C17.6662 13.413 16.92 12.6668 15.9995 12.6668C15.0791 12.6668 14.3329 13.413 14.3329 14.3335C14.3329 15.2539 15.0791 16.0001 15.9995 16.0001ZM15.9995 16.0001V23.5001"
        stroke={theme.palette.text.primary}
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TelemetryMenuIcon;
